var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "42px",
        height: "48px",
        viewBox: "0 0 42 48",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Final",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Winter---Active",
                transform: "translate(1.000000, 1.000000)",
                stroke: "#000000",
                "stroke-width": "2"
              }
            },
            [
              _c("line", {
                attrs: {
                  x1: "20.002",
                  y1: "0",
                  x2: "20.002",
                  y2: "46",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "0.082",
                  y1: "11.5",
                  x2: "39.92",
                  y2: "34.5",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "0.08",
                  y1: "34.502",
                  x2: "39.92",
                  y2: "11.5",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("polyline", {
                attrs: { id: "Path", points: "15.002 4 20.002 9 25.002 4" }
              }),
              _vm._v(" "),
              _c("polyline", {
                attrs: { id: "Path", points: "1.044 17.83 7.876 16 6.044 9.17" }
              }),
              _vm._v(" "),
              _c("polyline", {
                attrs: {
                  id: "Path",
                  points: "6.044 36.832 7.876 30 1.044 28.172"
                }
              }),
              _vm._v(" "),
              _c("polyline", {
                attrs: {
                  id: "Path",
                  points: "25.002 42.002 20 37 15.002 42.002"
                }
              }),
              _vm._v(" "),
              _c("polyline", {
                attrs: {
                  id: "Path",
                  points: "38.958 28.172 32.122 30.002 33.958 36.832"
                }
              }),
              _vm._v(" "),
              _c("polyline", {
                attrs: {
                  id: "Path",
                  points: "33.958 9.17 32.124 16.004 38.958 17.83"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "17.002",
                  y1: "14",
                  x2: "23.002",
                  y2: "14",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "10.706",
                  y1: "21.098",
                  x2: "13.706",
                  y2: "15.9",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "13.706",
                  y1: "30.1",
                  x2: "10.706",
                  y2: "24.904",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "23.002",
                  y1: "32.002",
                  x2: "17.002",
                  y2: "32.002",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "29.296",
                  y1: "24.902",
                  x2: "26.296",
                  y2: "30.1",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "26.294",
                  y1: "15.9",
                  x2: "29.296",
                  y2: "21.1",
                  id: "Path"
                }
              })
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f001a0d", { render: render, staticRenderFns: staticRenderFns })
  }
}